<template>
  <div class="inspection-list-container">
    <div class="jc-page-top">
      <div class="equipment-list">
        <div class="jc-page-header">
          <h1>
            <i class="jc-icon-my-circle-bold"></i>{{$t('text.deviceInspection ')}}
          </h1>
          <div class="jc-box-action">
            <a v-bind:href="Config.DEVICE_iNSPECTION_URL" this="_blank">{{$t('equipment.helpDoc',[$t('text.deviceInspection')])}}</a>
          </div>
        </div>

        <div class="jc-page-content">
          <div class="el-container-table">
            <!-- 表头操作 -->
            <div class="el-container-table-actionBar">
              <el-form class="el-box-table-search" :inline="true" @submit.native.prevent>
                <el-form-item>
                  <el-select id="my-select" v-model="currentSearch" @change="changeSearch" class="search-select-width">
                    <el-option class="my-select-input" v-for="item in searchSelect" :key="item.searchValue" :label="item.searchLabel" :value="item.searchValue"></el-option>
                  </el-select>
                  <el-input class="my-input" v-on:input="delAllSearchVal" clearable @clear="updateList('refresh')" @keyup.enter.native="filterBySearchValue" :placeholder="searchPlaceholder[currentSearch]" v-model="currentSearchValue">
                    <el-button slot="append" icon="el-icon-search" @click="filterBySearchValue" class="search-icon"></el-button>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button icon="jc-icon-refresh-line" class="jc-button-icon" @click="getRegionList(cacheParams, true)"></el-button>
                </el-form-item>
                <el-form-item class="set-icon">
                  <el-button icon="el-icon-setting" class="jc-button-icon" @click="customVisible = true" :title="$t('merge.customList')"></el-button>
                </el-form-item>
                <el-form-item>
                  <el-button class="jc-button-icon" icon="jc-icon-download" @click="exportList" :title="$t('speechcraft.exportResourceList')"></el-button>
                </el-form-item>
              </el-form>
              <el-form class="el-table-actionBar-item" :inline="true">
                <div style="margin-top:5px;display:inline-block">{{$t('text.inspectionDate')}}：</div>
                <el-form-item>
                  <el-date-picker class="bill-list-toolbar-select"
                    v-model="checkDate"
                    type="daterange"
                    @change="changeDate"
                    :editable="false"
                    :clearable="true"
                    :start-placeholder="$t('text.start_placeholder')"
                    :end-placeholder="$t('text.end_placeholder')">
                  </el-date-picker>
                </el-form-item>
              </el-form>

                    <!-- :picker-options="pickerOptions" -->
            </div>
            <div class="el-container-table">
              <el-table
                  :data="deviceData"
                  v-loading="refreshloading"
                  class="product-table"
                  @filter-change="changeFilter"
                  :empty-text="tableEmptyTip">

              <el-table-column prop="checkDate" :label="$t('text.inspectionDate')"
                                :formatter="maybeEmpty"
                                v-if="customInfo !== null && customInfo['checkDate'].selected"></el-table-column>
              <el-table-column prop="idcName"
                              :label="$t('merge.roomName')"
                              :formatter="maybeEmpty"
                              :filter-multiple="false"
                               :filters="fliter_region"
                               :filtered-value="filtersValue.idc"
                               columnKey="idc"
                               :filter-method="filtersRegion"
                                v-if="customInfo !== null && customInfo['region'].selected"> </el-table-column>
              <el-table-column prop="status" :label="$t('text.status')" :filter-multiple="false"
                               :filters="filterList.inspectionStatus"
                               :filtered-value="filtersValue.status"
                               columnKey="status"
                               :filter-method="filtersRegion" v-if="customInfo !== null && customInfo['status'].selected">
                <template slot-scope="scope">

                  <span :class="scope.row.status == 'abnormal' ? 'jc-status jc-status--red':'jc-status jc-status--green'">{{scope.row.statusName | maybeEmpty}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="deviceNo" :formatter="maybeEmpty" :label="$t('equipment.equipmentNumber')"  v-if="customInfo !== null && customInfo['deviceNo'].selected">
              </el-table-column>
              <el-table-column prop="snNo" :formatter="maybeEmpty" :label="$t('equipment.snNumber')"  v-if="customInfo !== null && customInfo['deviceNo'].selected">
              </el-table-column>
              <el-table-column prop="deviceTypeName" :filters="filterList.deviceType"
                               :filtered-value="filtersValue.deviceType"
                               columnKey="deviceType"
                               :filter-multiple="false"
                               :filter-method="filtersRegion" :formatter="maybeEmpty" :label="$t('equipment.equipmentType')"  v-if="customInfo !== null && customInfo['deviceNo'].selected">
              </el-table-column>
              <el-table-column prop="faultTypeName" :formatter="maybeEmpty" :label="$t('text.faultType')"  v-if="customInfo !== null && customInfo['deviceNo'].selected">
              </el-table-column>

            </el-table>
            </div>

        </div>
      </div>
    </div>
    <div class="el-page-footer block el-container-table-actionBar" v-if="deviceData.length">
      <el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
      <custom :visible.sync="customVisible" v-if="customVisible" :optionArr="optionArr" :type="type"></custom>
    </div>
  </div>
</template>


<script>
import { cloneDeep } from 'lodash';
import moment from 'moment';
import custom from '../../common/custom/Custom.vue';

export default {
  components: {
    custom
  },
  data() {
    return {
      checkDate: [],
      fliter_region: [],
      deviceData: [],
      currentPage: 1,
      pageSize: 20, // 默认每页20条
      pageSizes: [20, 50, 100], // 可选每页展示多少条
      total: 0,
      refreshLoading: false,
      tableEmptyTip: this.$t('text.noSearch'),
      tableEmptyMap: { // 表格提示文本
        search: this.$t('text.hasSearch'),
        noSearch: this.$t('text.noSearch')
      },
      // 自定义列表是否显示
      customVisible: false,
      // 自定义列表表头
      optionArr: [
        {
          label: this.$t('text.inspectionDate'),
          value: 'checkDate'
        }, {
          label: this.$t('merge.roomName'),
          value: 'region'
        },
        {
          label: this.$t('text.status'),
          value: 'status'
        },
        {
          label: this.$t('equipment.equipmentNumber'),
          value: 'deviceNo'
        }, {
          label: this.$t('equipment.snNumber'),
          value: 'snNo'
        },
        {
          label: this.$t('equipment.equipmentType'),
          value: 'deviceType'
        },
        {
          label: this.$t('text.faultType'),
          value: 'faultType'
        }
      ],
      // 自定义列表类型
      type: 'deviceInspection',
      detailVisible: false,
      detailData: null,
      filtersValue: {
        idc: [],
        status: [],
        deviceType: [],
      },
      // 模糊搜索下拉框
      searchSelect: [
        // 设备编码
        {
          searchValue: 'deviceNo',
          searchLabel: this.$t('equipment.equipmentNumber')
        },
        // SN号
        {
          searchValue: 'snNo',
          searchLabel: this.$t('equipment.snNumber'),
        }
      ],
      currentSearch: 'deviceNo',
      searchPlaceholder: {
        deviceNo: this.$t('placeholder.searchMoreDeviceNo'),
        snNo: this.$t('placeholder.searchMoreSN'),
      },
      currentSearchValue: '',
      cacheParams: null
    };
  },
  methods: {
    getFilterRegion () {
      this.$api.getRegions({ all: 1, idcLine: this.GLOBAL.IDCLINE }).then((res) => {
        if (res.errno === 10000 && res.errmsg === 'OK') {
          if (res.data && res.data.idcs.length > 0 && res.data.idcs[0] != null) {
            const data = res.data.idcs;
            this.fliter_region = [];
            for (let i = 0; i < data.length; i++) {
              this.fliter_region.push({
                value: data[i].idc,
                text: data[i].idcName
              });
            }
          } else {
            this.fliter_region = [];
          }
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    // 修改搜索条件
    changeSearch() {
      // 清空当前搜索条件
      this.currentSearchValue = '';
    },
    showDetail(data) {
      this.detailVisible = true;
      this.detailData = cloneDeep(data);
    },
    maybeEmpty (row, column) {
      const arr = row[column.property];
      const sign = '--';
      return arr || sign;
    },
    changeFilter (filter) {
      this.currentPage = 1;
      console.log(filter);
      Object.keys(filter).forEach((key) => {
        this.filtersValue[key] = filter[key];
      });
      const params = {};
      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length) {
          params[key] = this.filtersValue[key][0];
        }
      });
      this.getRegionList(params, true);
    },
    changeDate(val) {
      this.currentPage = 1;
      this.getRegionList();
    },
    // 按照指定搜索条件进行搜索
    filterBySearchValue() {
      this.currentPage = 1;
      this.tableEmptyTip = this.$t('text.noSearch');
      this.getRegionList();
    },
    delAllSearchVal() {
      this.currentPage = 1;
      if (this.currentSearchValue == '') {
        this.getRegionList('refresh');
      }
    },
    getRegionList (paramsArg = {}, search = false) {
      this.refreshloading = true;
      let params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };
      if (this.checkDate !== null && this.checkDate[0]) {
        params.startDate = moment(this.checkDate[0]).format('YYYY-MM-DD').trim();
        params.endDate = moment(this.checkDate[1]).format('YYYY-MM-DD').trim();
      }
      // 判断当前搜索条件，根据不同搜索条件设置不同的请求参数
      if (this.currentSearchValue != '') {
        switch (this.currentSearch) {
          // SN号
          case 'deviceNo': {
            params.deviceNo = this.$Pop.searchRegularConversion(this.currentSearchValue);
            break;
          }
          // 客户名称
          case 'snNo': {
            params.snNo = this.$Pop.searchRegularConversion(this.currentSearchValue);
            break;
          }
        }
      }
      Object.keys(this.filtersValue).forEach((key) => {
        if (this.filtersValue[key].length) {
          params[key] = this.filtersValue[key][0];
        }
      });
      params = Object.assign(params, paramsArg);
      // month: moment(this.searchValueMap.accountPeriod).format('YYYY-MM').trim(),
      // productLine: this.GLOBAL.IDCLINE

      this.cacheParams = cloneDeep(params);
      this.$api.getDeviceInspectionList(params).then((response) => {
        this.total = response.data.totalCount;
        this.refreshloading = false;
        if (response.data.deviceInspections.length === 1 && response.data.deviceInspections[0] === null) {
          this.deviceData = [];
        } else {
          this.deviceData = cloneDeep(response.data.deviceInspections);
        }
        if (!this.deviceData.length) { // 数据为空时展示的内容
          if (!search) {
            this.tableEmptyTip = this.tableEmptyMap.search;
          } else {
            this.tableEmptyTip = this.tableEmptyMap.noSearch;
          }
        }
      }).finally(() => {
        this.refreshloading = false;
      });
    },
    exportList() {
      let url = '/ccs-api/api/inspection/exportDeviceInspectionList?';
      Object.keys(this.cacheParams).forEach((key, index) => {
        if (!index) {
          url += `${key}=${this.cacheParams[key]}`;
        } else {
          url += `&${key}=${this.cacheParams[key]}`;
        }
      });
      url += '&all=1';
      window.open(url, '_self');
    },
    handleSizeChange(val) {
      this.pageSize = val;
      // console.log(this.pageSize)
      this.getRegionList();
    },
    filtersRegion () {
      return true;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // console.log(this.currentPage)
      this.getRegionList();
    },
    getCustomInfo() {
      const param = {
        pageKey: this.type
      };
      this.$api.getCustomInfo(param).then((response) => {
        // var response = JSON.parse(res)
        if (response.errno === 10000 && response.data.customInfo) {
          this.$store.commit('GET_CUSTOMINFO', { value: response.data.customInfo, type: this.type });
        }
      });
    }
  },
  created() {
    this.getFilterRegion();
    if (this.$store.state.customInfo[this.type] === null) {
      this.getCustomInfo();
    }
    this.getRegionList();
  },
  computed: {
    customInfo () {
      return this.$store.state.customInfo[this.type];
    },
    filterList () {
      return this.$store.state.filter.filterList;
    },
    regionFilters () {
      const arr = [];
      if (this.filterList.idcNo) {
        this.filterList.idcNo.forEach((value) => {
          const obj = {
            value: value.value,
            text: value.text.region
          };
          arr.push(obj);
        });
      }
      return arr;
    }
  },
  watch: {
  }
};
</script>
<style lang="scss">
.inspection-list-container {
  /* // 设置footer分页(勿动) */
  background-color: #ebf1f6;
  height: 100% ;
  overflow: auto;

  //消除table滚动
  .el-table__body-wrapper {
    overflow: hidden !important;
  }

  .search-select-width {
    width: 130px !important;
    margin-right: 5px !important;
    margin-bottom: 10px !important;
  }

  .search-input-width {
    width: 260px !important;
  }

  .el-form-item__content{
    line-height:30px !important
  }
}
.right {
  float: right;
}

.width90 {
  width: 90px !important;
}

.pages a.firstpage i,
.pages a.lastpage i {
  background: transparent !important;
}

.custom-header:after {
  content: ".";
  clear: both;
  height: 0;
  display: block;
  visibility: hidden;
}

.custom-header li {
  margin-top: 20px;
  margin-bottom: 20px;
}

.custom-header li label {
  float: left;
  width: 30%;
  padding-top: 10px;
  padding-left: 40px;
}
/* 调tool-bar */
.el-input-group__append {
  border-radius: 0 3px 3px 0 !important;
}
button.jc-button.jc-button--default.search-icon {
  border-left-width: 0px !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}
// i.jc-icon-search {
//   color: #d1d9de;
// }
input.jc-input__inner {
  border-radius: 3px 0 0 3px;
}
.jc-form-item.set-icon {
  margin-right: 8px !important;
}
/* 统一自定义风格（勿动） */
.jc-dialog.jc-dialog--tiny {
  width: 400px !important;
}
.normal-color{
    color:#008000;
  }
  .abnormal-color{
    color:#ff0000;
  }
</style>



// WEBPACK FOOTER //
// src/components/inspection/device/DeviceList.vue